import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["frame"]
  }

  static get values() {
    return {
      url: String
    }
  }

  spamButtonClicked(event) {
    if (event.target.classList.contains("disabled")) {
      return
    }

    let newUrl = new URL(window.location.origin + this.urlValue)
    Turbo.visit(newUrl.toString(), { frame: this.frameTarget.id })
  }
}
